var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconinformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 100C228.734 100 100 228.734 100 387.5C100 546.266 228.734 675 387.5 675C546.266 675 675 546.266 675 387.5C675 228.734 546.266 100 387.5 100Z",
    stroke: "#6D76E0",
    strokeWidth: 50,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.75 343.75H393.75V525",
    stroke: "#6D76E0",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M325 531.25H462.5",
    stroke: "#6D76E0",
    strokeWidth: 50,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 203.125C379.465 203.125 371.611 205.508 364.93 209.972C358.249 214.435 353.042 220.78 349.967 228.203C346.893 235.627 346.088 243.795 347.656 251.676C349.223 259.556 353.092 266.795 358.774 272.476C364.455 278.158 371.694 282.027 379.574 283.594C387.455 285.162 395.623 284.357 403.047 281.283C410.47 278.208 416.815 273.001 421.278 266.32C425.742 259.639 428.125 251.785 428.125 243.75C428.125 232.976 423.845 222.642 416.226 215.024C408.608 207.405 398.274 203.125 387.5 203.125Z",
    fill: "#6D76E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinformation);
export default __webpack_public_path__ + "static/media/iconinformation.4dc7da986ee329adabfe3684ccf8e62e.svg";
export { ForwardRef as ReactComponent };